import React, { useState, useEffect, useRef } from 'react'
import ReactLoading from 'react-loading'
import classnames from 'classnames'
import moment from 'moment'
import Field from '../../../dashboard/components/fields/Field'
import FieldNumber from '../../../dashboard/components/fields/FieldNumber'
import FieldCheckbox from '../../../dashboard/components/fields/FieldCheckbox'
import FieldRadio from '../../../dashboard/components/fields/FieldRadio'
import FieldDatePicker from '../../../dashboard/components/fields/FieldDatePicker'
import FieldSelect from '../../../dashboard/components/fields/FieldSelect'
import FieldTextarea from '../../../dashboard/components/fields/FieldTextarea'
import FieldEmail from '../../../dashboard/components/fields/FieldEmail'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'
import {
  arrayToDropdown,
  getAddressComponent,
  scrollToError,
  arrayToKeyValuePairForDropDown,
  arrayOfObjectsForDropDown,
} from '../../_utils'
import { validateForm, validateFormWithError } from '../../../dashboard/selectors/defaultSelectors'
import { axiosCreateWholesaler } from '../../../dashboard/actions/userActions'
import { handleAxiosErrors } from '../../../dashboard/_utils'
import { breakpoints } from '../../../dashboard/dom/_site'
import { segmentIdentifySignup } from '../../../dashboard/utils/segment/identify'
import { segmentTrackWholesalerSignup } from '../../../dashboard/utils/segment/track'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import { axiosGetSuburbList } from '../../../main/actions/formActions'
const availableEntityTypes = arrayToDropdown([
  'Company',
  'Discretionary Trust (Individual Trustee)',
  'Discretionary Trust (Corporate Trustee)',
  'Unit Trust (individual Trustee)',
  'Unit Trust (Corporate Trustee)',
  'Sole Trader',
  'Partnership',
])
const availableOutletTypes = arrayToDropdown([
  'Restaurant',
  'Bar',
  'Pub',
  'Club/Rsl/Sports/Cinema',
  'Hotel/Accommodation',
  'Events/Caterer',
  'Retail/Off-Premise',
])
const availableResturantStyles = arrayToDropdown(['Casual/Quick Service', 'Café', 'Fine Dining'])
const availableBarStyles = arrayToDropdown(['Specialist Bars', 'Cocktail Bars', 'Small Bars', 'Nightclub'])
const availablePubStyles = arrayToDropdown([
  'Gastro Pub',
  'Traditional',
  'Destination Pub',
  'Live Music Pub',
  'Backpacker/Student',
  'Campus',
  'Sports Bar',
  'Activity with beverage',
])
const availableClubStyles = arrayToDropdown([
  'RSL Clubs',
  'Members Clubs',
  'Cinemas',
  'Sports/Health Clubs',
  `Gentlemen\’s/Adult`,
  'Entertainment',
])
const availableHotelStyles = arrayToDropdown(['Hotels', 'Resorts', 'Casinos'])
const availableEventsStyles = arrayToDropdown([
  'Caterer',
  'Festivals',
  'Stadium',
  'Banquet Venues',
  'Government/Corporate',
  'Airlines',
  'Cruise Lines',
])

const availableOffPremiseStyles = arrayToDropdown([
  'Off-Premise Banner',
  'Hybrid - Bottle shop led',
  'Specialist',
  'Other retail',
])
const availableResturantOptions = arrayToDropdown([
  'Modern Australian',
  'European',
  'Italian',
  'French',
  'Latin American',
  'North American / Burger',
  'Thai',
  'Japanese',
  'Korean',
  'Chinese',
  'Asian',
])
const availableBarOptions = arrayToDropdown([
  'Whisky Bar',
  'Gin Bars',
  'Rum Bars',
  'Wine Bars',
  'Tequila Bars',
  'Other Specialist Bars',
  'Craft Beer Bar',
  'Cocktail Bar',
  'Late Night High Energy Venues',
])
const availableClubOptions = arrayToDropdown([
  'Golf Club',
  'Bowls Club',
  'Football/Cricket Club',
  'Fishing Club',
  'Tennis Club',
  'Yacht Club',
])
const availableHotelOptions = arrayToDropdown(['3-Star Hotel', '4-Star Hotel', '5-Star Hotel'])
const availableEventsOptions = arrayToDropdown([
  'Food-led Events',
  'Music-led Events',
  'Beverage-led events',
  'Exhibition Venues',
  'Caterers',
  'Banquet/Wedding Venues',
  'Sports Arenas',
  'Educational/Universities',
  'Financial Institutions',
  'Mining',
])
const availablePositions = arrayToDropdown([
  'CEO',
  'CFO',
  'Director',
  'Treasurer',
  'General Manager',
  'Venue Manager',
  'Procurement Manager',
])
const licenseNumberOptions = arrayToDropdown(['Enter License', 'Pending'])
const availableStates = arrayToKeyValuePairForDropDown([
  { id: 3, label: 'NSW' },
  { id: 5, label: 'QLD' },
  { id: 4, label: 'SA' },
  { id: 1, label: 'TAS' },
  { id: 2, label: 'VIC' },
  { id: 6, label: 'WA' },
  { id: 7, label: 'NT' },
  { id: 8, label: 'ACT' },
])
// avialble states with ids same as label
const availableStateNames = arrayToKeyValuePairForDropDown([
  { id: 'NSW', label: 'NSW' },
  { id: 'QLD', label: 'QLD' },
  { id: 'SA', label: 'SA' },
  { id: 'TAS', label: 'TAS' },
  { id: 'VIC', label: 'VIC' },
  { id: 'WA', label: 'WA' },
  { id: 'NT', label: 'NT' },
  { id: 'ACT', label: 'ACT' },
])
const referrals = arrayToDropdown(['Venue', 'Supplier', 'Paramount Sales Representative', 'Google', 'Social Media'])
const MINIMUM_COMMERCIAL_CREDIT_DIRECTORS = 1

const MOMENT_DISPLAY_FORMAT = 'DD/MM/YYYY'
const MOMENT_BACKEND_FORMAT = 'YYYY-MM-DD'

const WholesalerRegistrationForm = (props) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [newCustomerID, setNewCustomerID] = useState(null)
  const [activeStep, setActiveStep] = useState(1)
  const [isLoading, toggleLoading] = useState(false)
  const [clickSubmit, setClickSubmit] = useState(false)
  const [isValidated, setIsValidated] = useState(false)
  const [otherReferrals, setOtherReferrals] = useState(false)
  const [showAddressDetails, setShowAddressDetails] = useState(false)
  const [showLiquorLicenseNumberInput, setShowLicenseNumberInput] = useState(false)
  const [addManualAddress, setAddManualAddress] = useState(false)
  const [manualAddressField, setManualAddressField] = useState(false)
  const [formData, setFormData] = useState({
    DeliveryInstructions: '',
    CopyPostalAddressFromTradingAddress: false,
    CommercialCreditDirectors: [
      {}, // forces to create 1 object
    ],
    BusinessAddress: '',
    AgreeTerms: false,
    ApplyCommercialCreditTerms: false,
    // disableSuburb: true,
    // suburbsList: []
  })

  const lessThanMD = windowWidth < breakpoints.md
  const inputRefs = {}

  const moveToNextStep = () => {
    setActiveStep(activeStep + 1)
    scrollTop()
  }

  const moveToPrevStep = () => {
    setActiveStep(activeStep - 1)
    scrollTop()
  }
  /**
   * Handle default field update
   *
   * @param e
   */
  const handleFieldUpdate = (e) => {
    e.preventDefault()

    // Reset OutletStyle and Cuisine when OutletType is changed as they are dependent on OutletType
    if (e.target.name == 'OutletType') {
      updateFormData('OutletStyle', '')
      updateFormData('Cuisine', '')
    }

    // Use regex to remove leading spaces
    const { value } = e.target
    const sanitizedValue = value.replace(/^\s+/, '')
    updateFormData(e.target.name, sanitizedValue)
  }

  const handleNumberFieldUpdate = (e) => {
    e.preventDefault()

    // Use regex to remove leading spaces and non-numeric characters
    const { name, value } = e.target
    const sanitizedValue = value.replace(/^\s+/, '').replace(/[^0-9]/g, '')

    // Validation conditions for ACN and ABN
    if (name === 'ACN') {
      if (sanitizedValue.length <= 9) {
        updateFormData(name, sanitizedValue)
      } else {
        // Handle invalid ACN input (e.g., show an error message)
      }
    } else if (name === 'ABN') {
      if (sanitizedValue.length <= 11) {
        updateFormData(name, sanitizedValue)
      } else {
        // Handle invalid ABN input (e.g., show an error message)
      }
    } else {
      // Handle other fields or unknown field names
      updateFormData(name, sanitizedValue)
    }
  }

  /**
   * Handle all the toggle (checkboxes) field update that uses true / false
   *
   * @param e
   */
  const handleFieldToggle = (e) => {
    e.preventDefault()

    const value = formData[e.target.name] === undefined ? false : formData[e.target.name]

    updateFormData(e.target.name, !value)
  }

  /**
   * Handle all the checkboxes that allows multiple values in a field
   *
   * @param e
   */
  const handleFieldToggleMultiple = (e) => {
    e.preventDefault()

    const name = e.target.name
    const value = e.target.value

    const currentArrayValue = formData[name] || {}
    const currentSingleValue =
      formData[name] !== undefined && formData[name][value] !== undefined ? formData[name][value] : true

    const newValue = {
      ...currentArrayValue,
      [value]: !currentSingleValue,
    }

    updateFormData(e.target.name, newValue)
  }

  /**
   * Our main data setter to update the formData
   *
   * @param name
   * @param value
   */
  const updateFormData = (name, value) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [name]: value,
      }
    })
  }

  /**
   * Our main data setter to update formData inside an array
   *
   * @param arrayKey
   * @param arrayPos
   * @param name
   * @param value
   */
  const updateFormDataArray = (arrayKey, arrayPos, name = null, value = null) => {
    // Use regex to remove leading spaces
    let sanitizedValue = ''
    if (value) {
      sanitizedValue = value.replace(/^\s+/, '')
    }

    setFormData((prevState) => {
      let newState = {
        ...prevState,
      }

      if (newState[arrayKey] === undefined) {
        newState[arrayKey] = []
      }

      if (newState[arrayKey][arrayPos] === undefined) {
        newState[arrayKey][arrayPos] = {}
      }

      if (name) {
        newState[arrayKey][arrayPos][name] = sanitizedValue
      }

      return newState
    })
  }

  /**
   * Helper function to remove array from an element
   *
   * @param arrayKey
   * @param arrayPos
   */
  const removeFormDataArrayElement = (arrayKey, arrayPos) => {
    setFormData((prevState) => {
      let newState = {
        ...prevState,
      }

      if (newState[arrayKey] === undefined) {
        newState[arrayKey] = []
      }

      if (newState[arrayKey][arrayPos] === undefined) {
        newState[arrayKey][arrayPos] = {}
      }

      if (newState[arrayKey][arrayPos] !== undefined) {
        newState[arrayKey].splice(arrayPos, 1)
      }

      return newState
    })
  }

  /**
   * Generate post data for form submission
   * @param data
   */
  const buildPostData = (data) => {
    let postData = { ...data }

    const getCommaCombinedValues = (item) => {
      return Object.entries(item)
        .reduce((accumulator, [key, status]) => {
          if (status === true) {
            accumulator.push(key)
          }

          return accumulator
        }, [])
        .join(', ')
    }

    // ACN
    if (!requireACN()) {
      delete postData.ACN
    }

    /**
     * Remove field from form data if other option is not selected so validation will not fail
     */
    if (postData.ReferralSourced !== 'Other') {
      delete postData.OtherReferralSourced
    }

    if (manualAddressField) {
      postData.BusinessAddress = `${postData?.BusinessCity || ''} ${postData?.BusinessPostalCode || ''} ${
        postData?.BusinessState || ''
      }`
    }
    // DOB
    if (postData.DOB) {
      postData.DOB = moment(postData.DOB, MOMENT_DISPLAY_FORMAT).format(MOMENT_BACKEND_FORMAT)
    }

    // Commercial Credit Terms related
    if (activeStep !== 3 || postData.ApplyCommercialCreditTerms === false) {
      ;[
        'CommercialCreditDirectors',
        'InternalAccountsPayableFirstName',
        'InternalAccountsPayableSurname',
        'InternalAccountsPayableContactNumber',
        'InternalAccountsPayableEmail',
      ].forEach((key) => {
        if (postData[key] !== undefined) {
          delete postData[key]
        }
      })
    }

    if (postData.CommercialCreditDirectors) {
      postData.CommercialCreditDirectors.map((item) => {
        return {
          ...item,
          DOB: moment(item.DOB, MOMENT_DISPLAY_FORMAT).format(MOMENT_BACKEND_FORMAT),
        }
      })
    }

    return postData
  }

  const accountHolderInformationError = useRef(null)
  const mainContactInformationError = useRef(null)
  const commercialCreditError = useRef(null)
  const agreeTermsError = useRef(null)

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // This adds a smooth scrolling effect
    })
  }

  const executeScroll = (ref) => {
    ref?.current?.scrollIntoView()

    const scrolledY = window.scrollY

    // now account for fixed header
    const contentElement = document.getElementById('header')
    const headerHeight = contentElement.offsetHeight + 10 // 10 is just a padding

    if (scrolledY) {
      window.scroll(0, scrolledY - headerHeight)
    }
  }

  function handleReferrals(e) {
    e.preventDefault()

    let newValue = e.target.value
    const sanitizedValue = newValue.replace(/^\s+/, '')

    if (e.target.name === 'OtherReferralSourced') {
      updateFormData(e.target.name, sanitizedValue)
      return
    } else if (e.target.value !== 'Other') {
      setOtherReferrals(false)
      setFormData((prevState) => {
        const { OtherReferralSourced, ...rest } = prevState
        return rest
      })
      updateFormData(e.target.name, sanitizedValue)

      return
    }
    updateFormData(e.target.name, sanitizedValue)
    setFormData((prevState) => {
      const { OtherReferralSourced, ...rest } = prevState
      return rest
    })
    setOtherReferrals(true)
  }

  /**
   * Handle form submission
   *
   * @param e
   */
  const handleFormSubmit = (e) => {
    e.preventDefault()

    if (activeStep == 3) {
      setClickSubmit(true)
    } else {
      setClickSubmit(false)
    }

    const postData = buildPostData(formData)

    const {
      LegalEntityName,
      TradingName,
      EntityType,
      ABN,
      ACN,
      LiquorLicenseNumber,
      OutletType,
      OutletStyle,
      Cuisine,
      BusinessAddress,
      BusinessCity,
      ReferralSourced,
      OtherReferralSourced,
      BusinessState,
      BusinessPostalCode,
      UnitNumber,
      StreetNumber,
      FirstName,
      Surname,
      DOB,
      Position,
      ContactNumber,
      Email,
      ConfirmEmail,
      AgreeTerms,
      LiquorLicenseNumberInput,
    } = formData

    validateFormWithError(inputRefs)

    if (activeStep == 2 && addManualAddress === false && showAddressDetails === false) {
      if (inputRefs.BusinessAddress.field?.classList?.length > 0) {
        inputRefs.BusinessAddress.field?.classList.remove('field--success')
        inputRefs.BusinessAddress.field?.classList.add('field--alert')
        // inputRefs.BusinessAddress.field?.classList.add('field__alert')
        scrollToError()
        return
      }
    }
    if (activeStep == 1 && (!FirstName || !Surname || !ContactNumber || !Email || !TradingName)) {
      // if (Email !== ConfirmEmail) {
      // }
      scrollToError()
      return
    }

    if (
      activeStep == 2 &&
      (!LegalEntityName ||
        !TradingName ||
        !EntityType ||
        !ABN ||
        (requireACN() && !ACN) ||
        !ReferralSourced ||
        (otherReferrals && !OtherReferralSourced) ||
        (showLiquorLicenseNumberInput && !LiquorLicenseNumberInput) ||
        !LiquorLicenseNumber ||
        !OutletType ||
        !OutletStyle ||
        !BusinessAddress ||
        !BusinessCity ||
        !BusinessState ||
        !BusinessPostalCode ||
        // !UnitNumber ||
        !StreetNumber ||
        (OutletType !== 'Pub' && OutletType !== 'Retail/Off-Premise' && !Cuisine))
    ) {
      scrollToError()
      return
    }

    if (activeStep == 3 && !AgreeTerms) {
      scrollToError()
      return
    }

    if ((activeStep == 2 || activeStep == 3) && LiquorLicenseNumber === 'Enter License') {
      postData.LiquorLicenseNumber = LiquorLicenseNumberInput
    }

    delete postData.LiquorLicenseNumberInput

    /**
     * set state label for BusinessState instead of id
     */
    // postData.BusinessState = availableStates.find(state => state.value === parseInt(BusinessState)).label
    // delete postData.suburbsList
    if (newCustomerID) {
      postData['ID'] = newCustomerID
    }

    if (activeStep == 3) {
      postData['IsFinalStep'] = true
    } else {
      postData['ApplyCommercialCreditTerms'] = false
    }
    if (isValidated) {
      toggleLoading(true)

      return axiosCreateWholesaler(postData)
        .then((response) => {
          if (response.status === 200) {
            let ID = response?.data?.data?.createOrUpdateWholesalerRegistration?.ID || null
            if (ID && (activeStep == 1 || activeStep == 2)) {
              setNewCustomerID(parseInt(ID))
              moveToNextStep()
            } else {
              segmentIdentifySignup({
                ...postData,
                ID: ID,
              })

              segmentTrackWholesalerSignup({
                ...postData,
                ID: ID,
              })
              setTimeout(() => {
                window.location.href = '/application-submitted'
              }, 1000)
            }
          }
        })
        .catch((error) => {
          console.log(error)
          handleAxiosErrors(error)
        })
        .then(() => {
          toggleLoading(false)
        })
    } else {
      scrollToError()
      return
      // executeScroll(commercialCreditError)
    }
  }

  /**
   * description : if Pending is selected then show the input field for license number
   * @param {*} e
   */
  const handleLicenseNumberInput = (e) => {
    // if the value from e is Enter LicenseSed cumque omnis rep then set license number to Enter license and set the showLiquorLicenseNumberInput to true else showLiquorLicenseNumberInput to false
    if (e.target.value === 'Enter License') {
      updateFormData('LiquorLicenseNumber', e.target.value)
      setShowLicenseNumberInput(true)
    } else {
      updateFormData('LiquorLicenseNumber', e.target.value)
      setShowLicenseNumberInput(false)
    }
  }
  /**
   * Helper function to check if we need ACN or not
   *
   * @returns {boolean}
   */
  const requireACN = () => {
    if (formData?.EntityType) {
      if (
        formData.EntityType === 'Company' ||
        formData.EntityType === 'Discretionary Trust (Corporate Trustee)' ||
        formData.EntityType === 'Unit Trust (Corporate Trustee)'
      ) {
        return true
      }
    }

    return false
  }

  /**
   * Helper function to check if all object keys has false value
   *
   * @returns {boolean}
   */
  const hasFalseValue = (obj) => {
    // return Object.keys(obj).every(k => !obj[k])
  }

  /**
   * Function to handle the suburb data
   * @returns {void}
   */
  const setSuburbData = () => {
    const { BusinessState, BusinessPostalCode } = formData
    if (BusinessState && BusinessPostalCode) {
      axiosGetSuburbList(BusinessState, BusinessPostalCode)
        .then((response) => {
          if (response?.data?.data?.readSuburbs?.length > 0) {
            setFormData((prevState) => ({
              ...prevState,
              suburbsList: arrayOfObjectsForDropDown(response?.data?.data?.readSuburbs, 'City'),
              disableSuburb: false,
            }))
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }

  // Validate using useEffect
  useEffect(() => {
    // Basic validation
    const status = !validateForm(inputRefs)
    setIsValidated(status)
  }, [JSON.stringify(formData), activeStep])

  // Window Width using useEffect
  useEffect(() => {
    const updateWindowDimensions = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', () => updateWindowDimensions())

    return () => {
      window.removeEventListener('resize', () => updateWindowDimensions())
    }
  }, [])

  const handleGeoChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      BusinessAddress: e,
    }))
    setAddManualAddress(false)
    // console.log(e)
  }
  const handleGeoSelect = (address) => {
    // console.log(address, 'address')
    geocodeByAddress(address)
      //   .then(results => getLatLng(results[0]) )
      .then((results) => {
        console.log(results, 'results')
        const address = results?.[0]
        // console.log(address, 'address')
        // const BusinessCity = getAddressComponent('locality', address?.address_components || '')
        // const BusinessState = getAddressComponent(
        //   'administrative_area_level_1',
        //   address?.address_components || '',
        //   'short_name'
        // )
        // const BusinessPostalCode = getAddressComponent('postal_code', address?.address_components || '')
        // const suburb = getAddressComponent('locality', address?.address_components || '')
        const postalCode = getAddressComponent('postal_code', address?.address_components || '')
        const suburb = getAddressComponent('locality', address?.address_components || '')
        const state = getAddressComponent(
          'administrative_area_level_1',
          address?.address_components || '',
          'short_name'
        )
        const streetNumber = getAddressComponent('street_number', address?.address_components || '')
        const StreetName = getAddressComponent('route', address?.address_components || '')
        const unitNumber = getAddressComponent('subpremise', address?.address_components || '')

        // console.log(postalCode, suburb, state, 'address')
        setFormData((prev) => ({
          ...prev,
          BusinessAddress: results?.[0]?.formatted_address || '',
          BusinessCity: suburb,
          BusinessState: state,
          BusinessPostalCode: postalCode,
          UnitNumber: unitNumber,
          StreetName: StreetName,
          StreetNumber: streetNumber,
        }))
        setShowAddressDetails(true)
        setAddManualAddress(true)
      })
      .catch((error) => console.error('Error', error))
  }
  const searchOptions = {
    componentRestrictions: { country: ['au'] },
  }
  const handleGoogleAddressError = (e) => {
    console.log(e, 'error')
    const { BusinessPostalCode, BusinessCity, BusinessState, ...rest } = formData
    setFormData(rest)
    setAddManualAddress(false)
    setShowAddressDetails(false)
  }
  const toggleAddressManually = (e) => {
    // remove keys BusinessPostalCode, BusinessCity, BusinessState from formData state using spread operator
    const { BusinessPostalCode, BusinessCity, BusinessState, ...rest } = formData
    setFormData(rest)
    setAddManualAddress(false)
    setShowAddressDetails(false)
  }

  const getAvailableOutletStyles = (type) => {
    switch (type) {
      case 'Restaurant':
        return availableResturantStyles
      case 'Bar':
        return availableBarStyles
      case 'Pub':
        return availablePubStyles
      case 'Club/Rsl/Sports/Cinema':
        return availableClubStyles
      case 'Hotel/Accommodation':
        return availableHotelStyles
      case 'Events/Caterer':
        return availableEventsStyles
      case 'Retail/Off-Premise':
        return availableOffPremiseStyles
      default:
        return []
    }
  }

  const getAvailableCuisineTypes = (type) => {
    switch (type) {
      case 'Restaurant':
        return availableResturantOptions
      case 'Bar':
        return availableBarOptions
      case 'Pub':
        return []
      case 'Club/Rsl/Sports/Cinema':
        return availableClubOptions
      case 'Hotel/Accommodation':
        return availableHotelOptions
      case 'Events/Caterer':
        return availableEventsOptions
      case 'Retail/Off-Premise':
        return []
      default:
        return []
    }
  }

  const availableOutletStyles = getAvailableOutletStyles(formData.OutletType)
  const availableCuisineTypes = getAvailableCuisineTypes(formData.OutletType)
  return (
    <React.Fragment>
      <div className="container steps-container mb-5">
        <ul className="progressbar">
          <li
            className={`active ${activeStep === 1 && 'selected'}`}
            onClick={() => {
              if (activeStep === 2 || activeStep === 3) {
                setActiveStep(1)
              }
            }}
          >
            <span>Account </span>
            <span>Information</span>
          </li>
          <li
            className={`${(activeStep === 2 || activeStep === 3) && 'active'} ${activeStep === 2 && 'selected'}`}
            onClick={() => {
              if (activeStep === 3) {
                setActiveStep(2)
              }
            }}
          >
            <span>Venue </span>
            <span>Information</span>
          </li>
          <li className={`${activeStep === 3 && 'active selected'}`}>
            <span>Credit </span>
            <span>Application</span>
          </li>
        </ul>
      </div>
      <form noValidate={true}>
        <div className="ms-form  wholesaler-form--container  mb-5">
          <div className="ms-form__wrapper">
            {activeStep === 1 && (
              <div className="row vspace">
                <div className="col-xs-12 col-md-6">
                  <Field
                    ref={(r) => (inputRefs.FirstName = r)}
                    required
                    sholdFocusInput
                    autoComplete="off"
                    value={formData.FirstName}
                    animatedlabel="Your First Name *"
                    label="Your First Name *"
                    name="FirstName"
                    onChange={handleFieldUpdate}
                  />
                </div>
                <div className="col-xs-12 col-md-6">
                  <Field
                    ref={(r) => (inputRefs.Surname = r)}
                    required
                    sholdFocusInput
                    autoComplete="off"
                    value={formData.Surname}
                    animatedlabel="Your Surname *"
                    label="Your Surname *"
                    name="Surname"
                    onChange={handleFieldUpdate}
                  />
                </div>
                <div className="col-xs-12 col-md-6">
                  <Field
                    ref={(r) => (inputRefs.ContactNumber = r)}
                    required
                    sholdFocusInput
                    autoComplete="off"
                    value={formData.ContactNumber}
                    animatedlabel="Your Contact Number *"
                    label="Your Contact Number *"
                    name="ContactNumber"
                    onChange={handleNumberFieldUpdate}
                  />
                </div>
                <div className="col-xs-12 col-md-6">
                  <FieldEmail
                    ref={(r) => (inputRefs.Email = r)}
                    required
                    sholdFocusInput
                    type="email"
                    autoComplete="off"
                    value={formData.Email}
                    animatedlabel="Your Email Address *"
                    label="Your Email Address *"
                    name="Email"
                    onChange={handleFieldUpdate}
                  />
                </div>
                <div className="col-xs-12 col-md-6">
                  <Field
                    ref={(r) => (inputRefs.TradingName = r)}
                    required
                    sholdFocusInput
                    autoComplete="off"
                    value={formData.TradingName}
                    animatedlabel="Venue Trading Name *"
                    label="Venue Trading Name *"
                    name="TradingName"
                    onChange={handleFieldUpdate}
                  />
                </div>
              </div>
            )}
            {activeStep === 2 && (
              <div className="row vspace">
                <div className="col-xs-12 col-md-6">
                  <Field
                    ref={(r) => (inputRefs.TradingName = r)}
                    required
                    sholdFocusInput
                    autoComplete="off"
                    value={formData.TradingName}
                    animatedlabel="Venue Trading Name *"
                    label="Venue Trading Name *"
                    name="TradingName"
                    // onChange={handleFieldUpdate}
                    disabled={true}
                    isDisabled={true}
                  />
                </div>
                <div className="col-xs-12 col-md-6">
                  <Field
                    ref={(r) => (inputRefs.LegalEntityName = r)}
                    required
                    sholdFocusInput
                    autoComplete="off"
                    value={formData.LegalEntityName}
                    animatedlabel="Legal Entity Name *"
                    label="Legal Entity Name *"
                    name="LegalEntityName"
                    suggestions
                    onChange={handleFieldUpdate}
                  />
                </div>
                <div className="col-xs-12 col-md-6">
                  <FieldSelect
                    ref={(r) => (inputRefs.EntityType = r)}
                    required
                    sholdFocusInput
                    autoComplete="off"
                    options={availableEntityTypes}
                    value={formData.EntityType}
                    animatedlabel="Entity Type *"
                    label="Entity Type *"
                    name="EntityType"
                    emptyValue="-- Select --"
                    onChange={handleFieldUpdate}
                  />
                </div>
                <div className="col-xs-12 col-md-6">
                  <Field
                    ref={(r) => (inputRefs.ABN = r)}
                    required
                    sholdFocusInput
                    autoComplete="off"
                    value={formData.ABN}
                    animatedlabel="ABN *"
                    label="ABN *"
                    name="ABN"
                    onChange={handleNumberFieldUpdate}
                  />
                </div>
                <div className="col-xs-12 col-md-6">
                  <Field
                    ref={(r) => (inputRefs.ACN = r)}
                    required={requireACN()}
                    sholdFocusInput
                    disabled={!requireACN()}
                    isDisabled={!requireACN()}
                    autoComplete="off"
                    value={formData.ACN}
                    animatedlabel="ACN"
                    label="ACN *"
                    name="ACN"
                    onChange={handleNumberFieldUpdate}
                  />
                </div>
                <div>
                  <div className="col-xs-12 col-md-6" style={{ position: 'relative' }}>
                    <span className="info-icon-liquor">
                      <OverlayTrigger
                        trigger={['hover', 'focus', 'click']}
                        placement={'top'}
                        overlay={
                          <Tooltip>
                            <p>
                              If you have applied for your Liquor Licence and are awaiting confirmation, please select
                              Pending.
                            </p>
                          </Tooltip>
                        }
                      >
                        <span className="product-form__case-icon">
                          <i className="material-icons" style={{ fontSize: '13px' }}>
                            error_outline
                          </i>
                        </span>
                      </OverlayTrigger>
                    </span>
                    <FieldSelect
                      ref={(r) => (inputRefs.LiquorLicenseNumber = r)}
                      required
                      sholdFocusInput
                      autoComplete="off"
                      options={licenseNumberOptions}
                      value={formData.LiquorLicenseNumber}
                      animatedlabel="Liquor License Number *"
                      label="Liquor License Number *"
                      name="LiquorLicenseNumber"
                      onChange={handleLicenseNumberInput}
                      emptyValue="-- Select --"
                    />
                  </div>
                  {showLiquorLicenseNumberInput && (
                    <div className="col-md-12 col-xs-12">
                      <Field
                        ref={(r) => (inputRefs.LiquorLicenseNumberInput = r)}
                        required
                        sholdFocusInput
                        autoComplete="off"
                        value={formData.LiquorLicenseNumberInput}
                        animatedlabel="Liquor License Number *"
                        label="Liquor License Number *"
                        name="LiquorLicenseNumberInput"
                        onChange={handleFieldUpdate}
                      />
                    </div>
                  )}
                </div>

                {/* Referrals Select */}
                <div className="col-xs-12 col-md-6">
                  <FieldSelect
                    ref={(r) => (inputRefs.ReferralSourced = r)}
                    required
                    sholdFocusInput
                    autoComplete="off"
                    options={referrals}
                    value={formData.ReferralSourced}
                    animatedlabel="Referral Source *"
                    label="Referral Source *"
                    name="ReferralSourced"
                    emptyValue="-- Select --"
                    onChange={handleReferrals}
                  />
                </div>

                <div className="col-xs-12 col-md-6">
                  <FieldSelect
                    ref={(r) => (inputRefs.OutletType = r)}
                    handleAxiosErrors
                    required
                    sholdFocusInput
                    autoComplete="off"
                    options={availableOutletTypes}
                    value={formData.OutletType}
                    animatedlabel="Outlet Type *"
                    label="Outlet Type *"
                    name="OutletType"
                    emptyValue="-- Select --"
                    onChange={handleFieldUpdate}
                  />
                </div>
                {formData?.OutletType && (
                  <div className="col-xs-12 col-md-6">
                    <FieldSelect
                      ref={(r) => (inputRefs.OutletStyle = r)}
                      handleAxiosErrors
                      required
                      sholdFocusInput
                      autoComplete="off"
                      options={availableOutletStyles}
                      value={formData.OutletStyle}
                      animatedlabel="Outlet Style *"
                      label="Outlet Style *"
                      name="OutletStyle"
                      emptyValue="-- Select --"
                      onChange={handleFieldUpdate}
                      disabled={!formData.OutletType}
                      isDisable={!formData.OutletType}
                    />
                  </div>
                )}

                {formData.OutletType && formData.OutletType !== 'Pub' && formData.OutletType !== 'Retail/Off-Premise' && (
                  <div className="col-xs-12 col-md-6">
                    <FieldSelect
                      ref={(r) => (inputRefs.Cuisine = r)}
                      handleAxiosErrors
                      sholdFocusInput
                      required={formData.OutletType !== 'Pub' || formData.OutletType !== 'Retail/Off-Premise'}
                      autoComplete="off"
                      options={availableCuisineTypes}
                      value={formData.Cuisine}
                      animatedlabel="Outlet Description *"
                      label="Outlet Description *"
                      name="Cuisine"
                      emptyValue="-- Select --"
                      onChange={handleFieldUpdate}
                    />
                  </div>
                )}

                {/* Other Referral Inout */}
                {otherReferrals && (
                  <div className="col-xs-12 col-md-6">
                    <Field
                      ref={(r) => (inputRefs.OtherReferralSourced = r)}
                      required={otherReferrals}
                      sholdFocusInput
                      autoComplete="off"
                      value={formData.OtherReferralSourced}
                      animatedlabel="Other Referral Source *"
                      label="Other Referral Source *"
                      name="OtherReferralSourced"
                      onChange={handleReferrals}
                    />
                  </div>
                )}

                <div className="col-xs-12 col-md-12 address--holder--customers mb-3">
                  {showAddressDetails && addManualAddress ? (
                    <button
                      onClick={() => {
                        toggleAddressManually(false)
                        setFormData((prev) => ({
                          ...prev,
                          BusinessAddress: '',
                          BusinessCity: '',
                          BusinessState: '',
                          BusinessPostalCode: '',
                          StreetNumber: '',
                          UnitNumber: '',
                        }))
                        setManualAddressField(false)
                      }}
                      type="button"
                      className="m-15 Ibutton button--third button--block search--bar--button button-center-align"
                    >
                      <img
                        className="mr-2 back-arrow"
                        src="/resources/themes/paramountliquor-theme/img/icon/arrow-left.png"
                      />
                      <span>Back to Address Search</span>
                    </button>
                  ) : (
                    <PlacesAutocomplete
                      value={formData.BusinessAddress}
                      onChange={handleGeoChange}
                      onSelect={handleGeoSelect}
                      searchOptions={searchOptions}
                      onError={handleGoogleAddressError}
                    >
                      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div>
                          <Field
                            ref={(r) => (inputRefs.BusinessAddress = r)}
                            name="address"
                            required
                            sholdFocusInput
                            placeholder="Search Places..."
                            animatedlabel="Address *"
                            label="Address *"
                            value={formData.BusinessAddress}
                            {...getInputProps({
                              placeholder: 'Start typing and select from the list',
                            })}
                          />
                          <div className="address-suggestions ml-3 maxWidth">
                            {loading && (
                              <div className="suggestion-item">
                                <span>Loading...</span>
                              </div>
                            )}
                            {suggestions.map((suggestion) => {
                              const className =
                                'suggestion-item ' + (suggestion.active ? 'suggestion-item--active' : '')

                              return (
                                <div
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                  })}
                                >
                                  <span>{suggestion.description}</span>
                                </div>
                              )
                            })}
                            {showAddressDetails === false && formData.BusinessAddress !== '' && !addManualAddress && (
                              <div className="suggestion-item">
                                <span
                                  onClick={() => {
                                    setShowAddressDetails(true)
                                    setAddManualAddress(true)
                                    setManualAddressField(true)
                                  }}
                                >
                                  <strong>Can’t find your address? Add Manually</strong>
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>
                  )}
                </div>
                {showAddressDetails ? (
                  <div>
                    <div className="col-xs-12 col-md-4">
                      <Field
                        ref={(r) => (inputRefs.UnitNumber = r)}
                        // required
                        sholdFocusInput
                        autoComplete="off"
                        value={formData.UnitNumber}
                        placeholder="Unit Number"
                        animatedlabel="Unit Number"
                        label="Unit Number"
                        name="UnitNumber"
                        onChange={(e) => {
                          handleFieldUpdate(e)
                          $(inputRefs.UnitNumber.field).find('.field__alert').remove()
                        }}
                      />
                    </div>
                    <div className="col-xs-12 col-md-4">
                      <Field
                        ref={(r) => (inputRefs.StreetNumber = r)}
                        required
                        sholdFocusInput
                        autoComplete="off"
                        value={formData.StreetNumber}
                        placeholder="Street Number *"
                        animatedlabel="Street Number *"
                        label="Street Number *"
                        name="StreetNumber"
                        onChange={(e) => {
                          handleFieldUpdate(e)
                          $(inputRefs.StreetNumber.field).find('.field__alert').remove()
                        }}
                      />
                    </div>
                    <div className="col-xs-12 col-md-4">
                      <Field
                        ref={(r) => (inputRefs.StreetName = r)}
                        required
                        sholdFocusInput
                        autoComplete="off"
                        value={formData.StreetName}
                        placeholder="Street Name *"
                        animatedlabel="Street Name *"
                        label="Street Name *"
                        name="StreetName"
                        onChange={(e) => {
                          handleFieldUpdate(e)
                          $(inputRefs.StreetName.field).find('.field__alert').remove()
                        }}
                        emptyValue="-- Select --"
                      />
                    </div>
                    <div className="col-xs-12 col-md-4">
                      <Field
                        ref={(r) => (inputRefs.BusinessCity = r)}
                        required
                        sholdFocusInput
                        autoComplete="off"
                        value={formData.BusinessCity}
                        placeholder="Suburb *"
                        animatedlabel="Suburb *"
                        label="Suburb *"
                        name="BusinessCity"
                        onChange={handleFieldUpdate}
                        emptyValue="-- Select --"
                      />
                    </div>
                    <div className="col-xs-12 col-md-4">
                      <FieldSelect
                        ref={(r) => (inputRefs.BusinessState = r)}
                        required
                        sholdFocusInput
                        autoComplete="off"
                        options={availableStateNames}
                        value={formData.BusinessState}
                        animatedlabel="State *"
                        label="State *"
                        name="BusinessState"
                        emptyValue="-- Select --"
                        onChange={(e) => {
                          handleFieldUpdate(e)
                          $(inputRefs.BusinessState.field).find('.field__alert').remove()
                        }}
                      />
                    </div>
                    <div className="col-xs-12 col-md-4">
                      <Field
                        ref={(r) => (inputRefs.BusinessPostalCode = r)}
                        required
                        sholdFocusInput
                        autoComplete="off"
                        value={formData.BusinessPostalCode}
                        placeholder="Postcode *"
                        animatedlabel="Postcode *"
                        label="Postcode *"
                        name="BusinessPostalCode"
                        onChange={(e) => {
                          handleFieldUpdate(e)
                          $(inputRefs.BusinessPostalCode.field).find('.field__alert').remove()
                        }}
                      />
                    </div>

                    {/* </div> */}
                    {/* City */}
                  </div>
                ) : (
                  ''
                )}
              </div>
            )}
            {activeStep === 3 && (
              <>
                <div className="vspace vspace--small">
                  <div className="vspace vspace--small">
                    <span className="heading heading--lv4">Would you like to apply for credit terms?</span>

                    <div className="row">
                      <div className="col-lg-2 col-xs-4">
                        <FieldRadio
                          ref={(r) => (inputRefs.ApplyCommercialCreditTerms = r)}
                          autoComplete="off"
                          value={formData.ApplyCommercialCreditTerms === false ? true : false}
                          label="Yes"
                          name="ApplyCommercialCreditTerms"
                          checked={formData.ApplyCommercialCreditTerms}
                          onChange={handleFieldToggle}
                        />
                      </div>
                      <div className="col-lg-2 col-xs-4">
                        <FieldRadio
                          ref={(r) => (inputRefs.ApplyCommercialCreditTerms = r)}
                          autoComplete="off"
                          value={formData.ApplyCommercialCreditTerms === true ? true : false}
                          label="No"
                          name="ApplyCommercialCreditTerms"
                          checked={!formData.ApplyCommercialCreditTerms}
                          onChange={handleFieldToggle}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {formData.ApplyCommercialCreditTerms === true && (
                  <div className="vspace vspace--small">
                    <div className="credit-section my-5">
                      <span className="heading heading--lv3 mb-0">Credit Application</span>
                      <div className="text-box">
                        <p>
                          Your account is being processed as a Prepaid account until your Credit Application is
                          processed. Check your emails for updates.
                        </p>
                      </div>
                    </div>
                    <div className="my-5">
                      <span className="heading heading--lv4">
                        Directors / Individual Trustees / Partners / Sole Proprietors
                      </span>
                      <div className="text-box">
                        <p>
                          Please enter details of <u>all</u> Directors / Individual Trustees / Partners / Sole
                          Proprietors
                        </p>
                      </div>
                      <div className="person-details">
                        {formData.CommercialCreditDirectors.map((item, key) => {
                          const arrayKey = 'CommercialCreditDirectors'
                          const arrayPos = key

                          return (
                            <div className="vspace vspace--small" key={key}>
                              <div className="row row--vcenter vspace vspace--small">
                                <div className="col-xs-8">
                                  <span className="heading heading--lv4">Person {key + 1}</span>
                                </div>
                                <div className="col-xs-4 tx-right">
                                  {key >= MINIMUM_COMMERCIAL_CREDIT_DIRECTORS && (
                                    <button
                                      type="button"
                                      className="button-link"
                                      onClick={(e) => removeFormDataArrayElement(arrayKey, arrayPos)}
                                    >
                                      Remove
                                    </button>
                                  )}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xs-12 col-md-6">
                                  <Field
                                    ref={(r) => (inputRefs[`${arrayKey}${arrayPos}-FullLegalName`] = r)}
                                    required
                                    sholdFocusInput
                                    autoComplete="off"
                                    value={item.FullLegalName}
                                    animatedlabel="Full Legal name *"
                                    label="Full Legal name *"
                                    name="FullLegalName"
                                    onChange={(e) =>
                                      updateFormDataArray(arrayKey, arrayPos, e.target.name, e.target.value)
                                    }
                                  />
                                </div>
                                <div className="col-xs-12 col-md-6">
                                  <Field
                                    ref={(r) => (inputRefs[`${arrayKey}${arrayPos}-HomeAddress`] = r)}
                                    required
                                    sholdFocusInput
                                    autoComplete="off"
                                    value={item.HomeAddress}
                                    animatedlabel="Home Address *"
                                    label="Home Address *"
                                    name="HomeAddress"
                                    onChange={(e) =>
                                      updateFormDataArray(arrayKey, arrayPos, e.target.name, e.target.value)
                                    }
                                  />
                                </div>
                                <div className="col-xs-12 col-md-6">
                                  <FieldDatePicker
                                    ref={(r) => (inputRefs[`${arrayKey}${arrayPos}-DOB`] = r)}
                                    className="steps-picker"
                                    required={!item.DOB}
                                    autoComplete="off"
                                    animatedlabel="Date of Birth *"
                                    label="Date of Birth *"
                                    dateFormat={MOMENT_DISPLAY_FORMAT}
                                    placeholder="dd/mm/yyyy"
                                    value={item.DOB}
                                    name="DOB"
                                    //onChange={value => updateFormDataArray(arrayKey, arrayPos, 'DOB', value)}
                                    onChange={(date) => {
                                      updateFormDataArray(arrayKey, arrayPos, 'DOB', date)
                                      // workaround
                                      $(inputRefs[`${arrayKey}${arrayPos}-DOB`].field).find('.field__alert').remove()
                                    }}
                                    withPortal={lessThanMD ? true : false}
                                  />
                                </div>
                                <div className="col-xs-12 col-md-6">
                                  <Field
                                    ref={(r) => (inputRefs[`${arrayKey}${arrayPos}-DriveLicenseNumber`] = r)}
                                    required
                                    sholdFocusInput
                                    autoComplete="off"
                                    value={item.DriveLicenseNumber}
                                    animatedlabel="Drivers License Number *"
                                    label="Drivers License Number *"
                                    name="DriveLicenseNumber"
                                    onChange={(e) => {
                                      const { name, value } = e.target
                                      updateFormDataArray(arrayKey, arrayPos, name, value)
                                    }}
                                  />
                                </div>
                                <div className="col-xs-12 col-md-6">
                                  <Field
                                    ref={(r) => (inputRefs[`${arrayKey}${arrayPos}-ContactNumber`] = r)}
                                    required
                                    sholdFocusInput
                                    autoComplete="off"
                                    value={item.ContactNumber}
                                    animatedlabel="Contact Number *"
                                    label="Contact Number *"
                                    name="ContactNumber"
                                    onChange={(e) => {
                                      const { name, value } = e.target
                                      const sanitizedValue = value.replace(/^\s+/, '').replace(/[^0-9]/g, '')
                                      updateFormDataArray(arrayKey, arrayPos, name, sanitizedValue)
                                    }}
                                  />
                                </div>
                                <div className="col-xs-12 col-md-6">
                                  <FieldEmail
                                    ref={(r) => (inputRefs[`${arrayKey}${arrayPos}-Email`] = r)}
                                    required
                                    sholdFocusInput
                                    type="email"
                                    autoComplete="off"
                                    value={item.Email}
                                    animatedlabel="Email Address *"
                                    label="Email Address *"
                                    name="Email"
                                    onChange={(e) =>
                                      updateFormDataArray(arrayKey, arrayPos, e.target.name, e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          )
                        })}
                        <button
                          type="button"
                          className="custom--button"
                          title="Add More"
                          onClick={(e) =>
                            updateFormDataArray('CommercialCreditDirectors', formData.CommercialCreditDirectors.length)
                          }
                        >
                          Add More
                        </button>
                      </div>
                    </div>

                    <div>
                      <span className="heading heading--lv4">Accounts Payable Contact Information</span>
                      <div className="text-box">
                        <p>Please enter your internal accounts payable contact information below:</p>
                      </div>
                      <div className="row">
                        <div className="col-xs-12 col-md-6">
                          <Field
                            ref={(r) => (inputRefs.InternalAccountsPayableFirstName = r)}
                            required
                            sholdFocusInput
                            autoComplete="off"
                            value={formData.InternalAccountsPayableFirstName}
                            animatedlabel="First Name *"
                            label="First Name *"
                            name="InternalAccountsPayableFirstName"
                            onChange={handleFieldUpdate}
                          />
                        </div>
                        <div className="col-xs-12 col-md-6">
                          <Field
                            ref={(r) => (inputRefs.InternalAccountsPayableSurname = r)}
                            required
                            sholdFocusInput
                            autoComplete="off"
                            value={formData.InternalAccountsPayableSurname}
                            animatedlabel="Surname *"
                            label="Surname *"
                            name="InternalAccountsPayableSurname"
                            onChange={handleFieldUpdate}
                          />
                        </div>
                        <div className="col-xs-12 col-md-6">
                          <Field
                            ref={(r) => (inputRefs.InternalAccountsPayableContactNumber = r)}
                            required
                            sholdFocusInput
                            autoComplete="off"
                            value={formData.InternalAccountsPayableContactNumber}
                            animatedlabel="Contact Number *"
                            label="Contact Number *"
                            name="InternalAccountsPayableContactNumber"
                            onChange={handleNumberFieldUpdate}
                          />
                        </div>
                        <div className="col-xs-12 col-md-6">
                          <FieldEmail
                            ref={(r) => (inputRefs.InternalAccountsPayableEmail = r)}
                            required
                            sholdFocusInput
                            type="email"
                            autoComplete="off"
                            value={formData.InternalAccountsPayableEmail}
                            animatedlabel="Email Address *"
                            label="Email Address *"
                            name="InternalAccountsPayableEmail"
                            onChange={handleFieldUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="vspace" ref={agreeTermsError}>
                  <FieldCheckbox
                    ref={(r) => (inputRefs.AgreeTerms = r)}
                    autoComplete="off"
                    value={formData.AgreeTerms === false ? true : false}
                    label="By clicking Agree and Continue button below, you're agreeing to our general <a href='/terms-and-conditions' target='_blank'>terms & conditions</a> of sale & supply"
                    name="AgreeTerms"
                    checked={formData.AgreeTerms}
                    onChange={handleFieldToggle}
                  />
                  {clickSubmit && formData.AgreeTerms === false && (
                    <span className="field--alert font-12">Agree the term is required</span>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <div className="msf-footer">
          {(activeStep === 2 || activeStep === 3) && (
            <button
              type="button"
              className={classnames('button button--third msf-footer__button')}
              title="Back"
              disabled={isLoading}
              onClick={() => moveToPrevStep()}
            >
              <span>Back</span>
            </button>
          )}
          {(activeStep === 1 || activeStep === 2) && (
            <button
              type="submit"
              className={classnames('button msf-footer__button', activeStep === 2 && 'ml-3')}
              title="Back"
              disabled={isLoading}
              onClick={handleFormSubmit}
            >
              <span style={{ opacity: isLoading ? 0 : 1 }}>Next</span>
              {isLoading === true && (
                <ReactLoading className="button__spinner" type="spin" color="white" height={25} width={25} />
              )}
            </button>
          )}

          {activeStep === 3 && (
            <button
              type="button"
              className={classnames('button msf-footer__button ml-3', isLoading && 'button--loading')}
              title="Submit"
              onClick={handleFormSubmit}
              disabled={isLoading}
            >
              <span style={{ opacity: isLoading ? 0 : 1 }}>Submit</span>
              {isLoading === true && (
                <ReactLoading className="button__spinner" type="spin" color="white" height={25} width={25} />
              )}
            </button>
          )}
        </div>
      </form>
    </React.Fragment>
  )
}

// default props
WholesalerRegistrationForm.defaultProps = {}
// validate props
WholesalerRegistrationForm.propTypes = {}

export default WholesalerRegistrationForm
